<template>
  <div id="app">
    <sidebar style="z-index:99"></sidebar>
    <footer class="footer">
      <a href="http://www.etsol.com.ar">Etsol</a>
      &copy; 2019 - {{$i18n.t('footer')}}
      <version></version>
    </footer>
  </div>
</template>

<script>
import sidebar from "./components/sidebar.vue";
import version from "./components/version.vue";
export default {
  components: {
    sidebar,
    version
  }
};
</script>

<style>
@import url("./css/w3.css");
/*@import url("./css/bootstrap.min.css");*/
@import url("https://use.fontawesome.com/releases/v5.7.0/css/all.css");
#app {
  font-family: Tahoma, "Geneva", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
/* .footer {
  position: inherit;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  background-color: #efefef;
  text-align: center;
  font-size: 10px;
  width: 100%;
} */
html {
  position: relative;
  min-height: 100%;
  height: auto;
  padding-bottom: 30px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 5px;
  text-align: center;
}
</style>
